export default __webpack_public_path__ + "static/media/cloud-background.cba20eba.png";